import Vue from 'vue'
import qs from 'qs'
import config from '@/config'

export default class {
  /**
   * 统一认证
   */
  static authorize (account) {
    return new Promise((resolve, reject) => {
      let params = {
        grant_type: 'password',
        username: account.username,
        password: account.password,
        client_id: 'web',
        client_secret: '',
        scope: 'all'
      }
      Vue.http({
        method: 'POST',
        url: config.api.url + '/oauth/token',
        // url: 'http://localhost:8088/upms/oauth/token',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify(params)
      }).then(res => {
        if (res && res.data.error) {
          reject(res.data)
        } else {
          resolve(res.data)
        }
      }).catch(error => {
        reject(error.data)
      })
    })
  }
  /**
   * 获取本应用的用户信息
   */
  static getInfo (token) {
    return new Promise((resolve, reject) => {
      Vue.http.get(config.api.url + '/employees/me', {}).then(res => {
        if (res && res.data.error) {
          reject(res.data)
        } else {
          resolve(res.data)
        }
      }).catch(error => {
        reject(error.data)
      })
    })
  }

  static signout (token) {
    return new Promise((resolve, reject) => {
      Vue.http.delete(config.api.url + '/oauth/token?client_id=web&access_token=' + token).then(res => {
        if (res.data.error) {
          reject(res.data)
        } else {
          resolve(res.data)
        }
      }).catch(error => {
        reject(error.data)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js